import React, { Component } from 'react';
import {
	IFundCardProps,
	IFundCardState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Card from '@kurtosys/ksys-app-components/dist/components/base/Card';
import Grid from '@kurtosys/ksys-app-components/dist/components/base/Grid';

@inject('appStore')
@observer
export class FundCard extends Component<IFundCardProps, IFundCardState> {
	static configurationKey: 'fundCard' = 'fundCard';
	static styleKey: 'fundCard' = 'fundCard';
	constructor(props: IFundCardProps) {
		super(props);
	}
	render() {
		const { className, fundCardStore } = this.props;

		if (!fundCardStore) {
			return null;
		}

		const {
			gridProps,
			queryStore,
			components,
		} = fundCardStore;

		return (
			<Wrapper className={ className }>
				{ gridProps && (
					<Grid
						queryStore={ queryStore }
						components={ components }
						noPropFlatten={ true }
						{ ...gridProps }
					/>
				) }
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(FundCard, 'fundCard');

